import { Box, HStack, Icon, Spacer, Text } from "@chakra-ui/react";
import { ReactElement, useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { NavLink } from "react-router";

import { MoreMenuNavbar } from "@/components/navbar/more-menu-navbar";
import { useNavbarPages } from "@/components/navbar/use-navbar-pages";
import { COLOR_TXT_PRIMARY, COLOR_TXT_SECONDARY } from "@/components/ui/theme";
import { AmplitudeTrackingEvent, trackAmplitudeEvent } from "@/lib/amplitude";

export const DesktopNavbar = () => {
  const { PUBLIC_PAGES, ADMIN_PAGES, MORE_PAGES } = useNavbarPages();
  return (
    <HStack direction="row" overflowX="auto">
      {PUBLIC_PAGES.map((page) => {
        const { name, to, icon, showExternalIcon } = page;
        return <StyledNavLink key={name} name={name} to={to} icon={icon} showExternalIcon={showExternalIcon} />;
      })}
      {ADMIN_PAGES.map((page) => {
        const { name, to, icon, showExternalIcon } = page;
        return <StyledNavLink key={name} name={name} to={to} icon={icon} showExternalIcon={showExternalIcon} />;
      })}
      {MORE_PAGES.length ? <MoreMenuNavbar pages={MORE_PAGES} /> : null}
    </HStack>
  );
};

const StyledNavLink = ({
  name,
  to,
  icon,
  showExternalIcon,
  shouldShowNotification,
}: {
  name: string;
  to: string;
  icon?: ReactElement;
  showExternalIcon?: boolean;
  shouldShowNotification?: boolean;
}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <NavLink
      key={name}
      to={to}
      target={to.startsWith("/") ? undefined : "_blank"}
      onClick={() => {
        trackAmplitudeEvent(AmplitudeTrackingEvent.PortalClickedNav, {
          nav_item: name,
        });
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={({ isActive }) => ({
        display: "flex",
        alignItems: "center",
        padding: "8px 12px",
        borderRadius: "24px",
        backgroundColor: isActive ? "#0000000D" : hovered ? "#F0F0F0" : "transparent",
        textDecoration: "none",
        color: isActive ? COLOR_TXT_PRIMARY : hovered ? COLOR_TXT_PRIMARY : COLOR_TXT_SECONDARY,
        fontWeight: "500",
        gap: "13px",
        fontSize: "14px",
        lineHeight: "20px",
        whiteSpace: "nowrap",
        height: "100%",
        letterSpacing: "-0.18px",
      })}
    >
      <HStack gap={0} w="full" justifyContent="center">
        <Icon boxSize={4}>{icon}</Icon>
        <Text ml={2}>{name}</Text>
        {(showExternalIcon || shouldShowNotification) && <Spacer flex={1} />}
        {showExternalIcon && (
          <FiArrowUpRight style={{ visibility: hovered ? "visible" : "hidden", width: "16px", height: "16px" }} />
        )}
        {shouldShowNotification && (
          <Box width="16px" height="16px" position="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              style={{ animation: "pulse 2s infinite" }}
            >
              <circle cx="8" cy="8" r="8" fill="#FDECDD" />
              <circle cx="8" cy="8" r="4" fill="#B95700" />
            </svg>
          </Box>
        )}
      </HStack>
    </NavLink>
  );
};
